import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import { smoothScroll } from "./components/smooth-scroll";
import { mobileNav } from "./components/mobile-nav";
import { filtering } from "./components/filtering";
import { accordion } from "./components/accordion";
import { heroVideo } from "./components/hero-video";
import AOS from 'aos';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import LiteYTEmbed from 'lite-youtube-embed';

// loads the Icon plugin
UIkit.use(Icons);

smoothScroll();
mobileNav();
filtering();
accordion();
heroVideo();
AOS.init();
